// eslint-disable-next-line import/prefer-default-export
export enum LocalStorageKeys {
  // save email
  LoginWithEmailLink = 'LoginWithEmailLink',
}
